"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewCallbackBanner = require("./NewCallbackBanner");
Object.keys(_NewCallbackBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewCallbackBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewCallbackBanner[key];
    }
  });
});